import { Pipe, PipeTransform } from '@angular/core';
import { ChatSession } from '../models/chat.models';

@Pipe({ name: 'xcActiveTitle' })
export class XcActiveTitlePipe implements PipeTransform {
  transform(sessions: ChatSession[] | null | undefined, activeId: string | null | undefined): string {
    if (!sessions || !activeId) return 'XEDGE AI Assistant';
    return sessions.find(s => s.id === activeId)?.title || 'XEDGE AI Assistant';
  }
}
